// src/pages/TherapistPage/CaseHistory/withdrawalApi.js
import api from '../../../services/api';

export const listRequests = (status = 'pending') =>
    api.get(`/consent/withdrawal-requests?status=${status}`);
export const getPlan = (requestId) =>
    api.get(`/consent/withdrawal-requests/${requestId}/plan`);
export const decide = (requestId, body) =>
    api.post(`/consent/withdrawal-requests/${requestId}/decision`, body);

// The children who are already gone. All that is left of them here is a code,
// and the bundles that code still sits inside.
export const listWithdrawn = () => api.get('/case-history/research/withdrawn');

export const withdrawalError = (err, fallback = 'Something went wrong. Try again.') =>
    err?.response?.data?.detail || fallback;
